// Địa chỉ API mà FE gọi tới — SUY THEO HOSTNAME đang chạy, không chốt cứng lúc build.
//
// Lý do (31/08/2026 — đợt đổi `cnvconnect.com` → `siteconnect.ai`): cụm Connect phải phục
// vụ HAI domain song song cho tới khi app iOS/Android bản mới được táo duyệt và phủ đủ máy
// khách. Nếu địa chỉ API bị nướng vào ảnh Docker lúc build (`VITE_API_BASE_URL`) thì một
// trong hai hub sẽ luôn gọi sang API của domain kia: chạy được (CORS đã mở hai chiều) nhưng
// mỗi lần đổi domain lại phải dựng ảnh mới, và ngày cắt domain cũ là hub mới chết theo.
//
// Quy tắc `hub.` / `console.` → `api.` là thứ `admin/public/sw.js` đã dùng từ 16/08 và đã
// chạy đúng trên prod; đây chỉ là mang nó sang phía trang. Đúng cho cả hai domain hiện tại
// và cho mọi domain sau này mà không phải sửa gì.
//
// `VITE_API_BASE_URL` VẪN là đường lùi: máy lập trình (localhost), bản xem thử, và mọi
// hostname không theo quy ước `hub.`/`console.` đều rơi về nó như trước.
export function resolveApiBase() {
  if (typeof window !== 'undefined') {
    const h = window.location.hostname;
    for (const prefix of ['hub.', 'console.']) {
      if (h.startsWith(prefix)) return `https://api.${h.slice(prefix.length)}/api/v1`;
    }
  }
  return import.meta.env.VITE_API_BASE_URL || '/api/v1';
}
